/**
 * Global functions for development/debugging purposes
 */

/**
 * Sets the PreMeeting screen as done, allowing to bypass it
 */
export const skipPreMeeting = (): void => {
    sessionStorage.setItem('isPreMeetingDone', 'true')
    console.log('PreMeeting screen has been marked as completed')
}

export const skipPermissions = (): void => {
    sessionStorage.setItem('isPermissionsDone', 'true')
    console.log('Permissions screen has been avoided')
}

// Expose functions to window for console access
declare global {
    interface Window {
        eggFunctions: {
            skipPreMeeting: typeof skipPreMeeting,
            skipPermissions: typeof skipPermissions
        }
    }
} 